/* Google Analytics 4 + Meta Pixel + Search Console verification + Pageview tracker.
   Reads IDs from env vars; gracefully no-ops if missing. */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const GA_ID = process.env.REACT_APP_GA_ID || "";
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";
const GOOGLE_SITE_VERIFICATION = process.env.REACT_APP_GOOGLE_SITE_VERIFICATION || "";

let scriptsInjected = false;

const inject = () => {
    if (scriptsInjected) return;
    scriptsInjected = true;

    if (GA_ID) {
        const s1 = document.createElement("script");
        s1.async = true;
        s1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
        document.head.appendChild(s1);
        const s2 = document.createElement("script");
        s2.innerHTML = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${GA_ID}',{send_page_view:false});`;
        document.head.appendChild(s2);
    }

    if (META_PIXEL_ID) {
        const s = document.createElement("script");
        s.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${META_PIXEL_ID}');`;
        document.head.appendChild(s);
    }
};

export default function Analytics() {
    const loc = useLocation();
    useEffect(() => { inject(); }, []);
    useEffect(() => {
        if (GA_ID && window.gtag) {
            window.gtag("config", GA_ID, { page_path: loc.pathname + loc.search });
        }
        if (META_PIXEL_ID && window.fbq) {
            window.fbq("track", "PageView");
        }
    }, [loc.pathname, loc.search]);

    return (
        <Helmet>
            {GOOGLE_SITE_VERIFICATION && (
                <meta name="google-site-verification" content={GOOGLE_SITE_VERIFICATION} />
            )}
        </Helmet>
    );
}
